/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type portfolio_CreatePortfolioScaleRequest = {
    childcare_id?: string;
    is_active: boolean;
    label_default: string;
    label_translations?: Record<string, string>;
    scale_key: string;
    scale_type: portfolio_CreatePortfolioScaleRequest.scale_type;
    sort_order?: number;
};
export namespace portfolio_CreatePortfolioScaleRequest {
    export enum scale_type {
        BINARY = 'binary',
        TRI_STATE = 'tri_state',
        LIKERT_4 = 'likert_4',
        ORDINAL_5 = 'ordinal_5',
        NARRATIVE_ONLY = 'narrative_only',
    }
}

